/**
 * @author Fernando Ruano
 * @file actions.js
 * @description MedicalParameter Actions
 */

// Constants
import {
  GET_ALL_MEDICAL_PARAMETERS,
  CREATE_MEDICAL_PARAMETER,
  UPDATE_MEDICAL_PARAMETER,
  GET_MEDICAL_PARAMETER_BY_ID,
  DELETE_MEDICAL_PARAMETER_BY_ID
} from './constants';

/**
 * Call process to get all medical parameters list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_MEDICAL_PARAMETERS
 */
export const getMedicalParametersArray = (data, callback) => ({
  type: GET_ALL_MEDICAL_PARAMETERS,
  payload: { data },
  callback
});

/**
 * Call process to get medical parameter by id
 * @param  { object } data - Medical Parameter Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getMedicalParameterById = (data, callback) => ({
  type: GET_MEDICAL_PARAMETER_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to create medical parameter
 * @param  { object } data - Medical Parameter Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_MEDICAL_PARAMETER
 */
export const createMedicalParameter = (data, callback) => ({
  type: CREATE_MEDICAL_PARAMETER,
  payload: { data },
  callback
});

/**
 * Call process to update medical parameter
 * @param  { object } data - Medical Parameter Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_MEDICAL_PARAMETER
 */
export const updateMedicalParameter = (data, callback) => ({
  type: UPDATE_MEDICAL_PARAMETER,
  payload: { data },
  callback
});

/**
 * Call process to delete medical parameter
 * @param  { object } data - Medical Parameter Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_MEDICAL_PARAMETER
 */
export const deleteMedicalParameterById = (data, callback) => ({
  type: DELETE_MEDICAL_PARAMETER_BY_ID,
  payload: { data },
  callback
});
